import { render, staticRenderFns } from "./MasterChain.vue?vue&type=template&id=49cab4ca&"
import script from "./MasterChain.vue?vue&type=script&lang=js&"
export * from "./MasterChain.vue?vue&type=script&lang=js&"
import style0 from "./MasterChain.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports